const FountainPreview = ({ fountainData }) => {
  if (!fountainData || !fountainData.tokens) {
    return (
      <div className="text-slate-400 text-center py-8">
        Start typing to see formatted preview...
      </div>
    );
  }

  const renderToken = (token, index) => {
    // Preserve line breaks within text
    const renderText = (text) => {
      if (!text) return null;
      return text.split('\n').map((line, i) => (
        <span key={i}>
          {line}
          {i < text.split('\n').length - 1 && <br />}
        </span>
      ));
    };

    switch (token.type) {
      case 'scene_heading':
        return (
          <div key={index} className="font-bold uppercase mt-8 mb-3">
            {renderText(token.text)}
          </div>
        );

      case 'action':
        return (
          <div key={index} className="my-4 whitespace-pre-wrap">
            {renderText(token.text)}
          </div>
        );

      case 'character':
        return (
          <div key={index} className="ml-[0.7in] mt-5 mb-1 font-bold uppercase">
            {renderText(token.text)}
          </div>
        );

      case 'dialogue':
        return (
          <div key={index} className="ml-0 mr-[0.5in] mb-3 whitespace-pre-wrap max-w-[3.5in]">
            {renderText(token.text)}
          </div>
        );

      case 'parenthetical':
        return (
          <div key={index} className="ml-[0.1in] mr-[0.5in] my-1 italic text-slate-600 max-w-[3.5in]">
            {renderText(token.text)}
          </div>
        );

      case 'transition':
        return (
          <div key={index} className="text-right font-bold uppercase my-4">
            {renderText(token.text)}
          </div>
        );

      case 'page_break':
        return (
          <div key={index} className="my-8 border-t-2 border-slate-300 relative">
            <span className="absolute left-1/2 top-0 -translate-x-1/2 -translate-y-1/2 bg-slate-50 px-3 text-xs text-slate-400">
              PAGE BREAK
            </span>
          </div>
        );

      default:
        return (
          <div key={index} className="my-2 text-slate-700 whitespace-pre-wrap">
            {renderText(token.text)}
          </div>
        );
    }
  };

  return (
    <div className="font-mono text-sm leading-relaxed w-full mx-auto bg-white shadow-lg min-h-[11in]">
      {/* Standard screenplay margins: 1.5" left, 1" right, 1" top/bottom */}
      <div className="max-w-[6in] mx-auto pl-[1.5in] pr-[1in] py-16">
        {fountainData.tokens.map(renderToken)}
      </div>
    </div>
  );
};

export default FountainPreview;
